import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Essay } from "./Types";

export default function (props: {
    setEssay: (essay: Essay) => void;
    slug?: string;
}) {

    const [contents, setContentsInner] = useState<string>();
    const [loadedSlug, setLoadedSlug] = useState<string | null>();

    if (!props.slug) {
        return (null)
    }

    const setContents = (newContents: string)=>{
        setContentsInner(newContents);
    }


    if (!contents || (props.slug !== loadedSlug)) {
        fetch(`${process.env.PUBLIC_URL}/essays/content/${props.slug}.md`)
            .then(res => res.status === 200 ? res.text() : "#Error loading essay")
            .then((essayContent: string) => {
                setContents(essayContent);
                setLoadedSlug(props.slug)
            })
            .catch((reason: any) => {
                setContents(
                    "# Error loading essay  "
                    + `${reason}`
                )
                setLoadedSlug(null);
            })

    }

    if (!contents) {
        return (
            <div>
                Error loading "{props.slug}"...
            </div>
        )

    }

    return (
        <div className="EssayContent">
            <ReactMarkdown
                source={contents || ""}
            />
        </div>
    )

}